<input type="file" class="file-input" [accept]="this.accept" (change)="onFileSelected($event)" #fileUpload>

<div class="file-upload">

  <div class="filename" [class.active]="this.name != null" (click)="onFileDownload($event)">{{ name || ('nofile' | translate) }}</div>

  @if (this.name == null) {
    <button type="button" nbButton size="small" outline status="basic" (click)="pick(fileUpload)">
      <nb-icon icon="attach"></nb-icon>&nbsp;{{ 'attachfile' | translate }}
    </button>
  }

  @if (this.name) {
    <button type="button" nbButton size="small" outline status="primary" (click)="onFileDownload($event)">
      <nb-icon icon="cloud-download-outline"></nb-icon>&nbsp;{{ 'download' | translate }}
    </button>
  }
  @if (this.name) {
    <button type="button" nbButton size="small" outline status="danger" (click)="onFileClear($event)">
      <nb-icon icon="trash-2-outline"></nb-icon>
    </button>
  }

  @if (this.progress > 0 && this.progress < 100 && !this.name) {
    <nb-progress-bar status="info" [value]="this.progress" [displayValue]="true"></nb-progress-bar>
  }
</div>
